import {login, logout} from '@/assets/js/api/login'

const user = {
  state: {
    token: '',
    username: '',
    realname: '',
    avatar: '',
    info: {},
    supplierInfo: {}
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, { username, realname, welcome }) => {
      state.username = username
      state.realname = realname
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_SUPPLIERINFO: (state, supplierInfo) => {
      state.supplierInfo = supplierInfo
    },
  },
  actions: {
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          if(response.code =='200'){
            const result = response.result
            const userInfo = result.userInfo
            const supplierInfo = result.supplierInfo
            localStorage.setItem('Access-Token', result.token, 60 * 60 * 1000)
            localStorage.setItem('username', userInfo.username, 60 * 60 * 1000)
            localStorage.setItem('phone', userInfo.phone, 60 * 60 * 1000)
            localStorage.setItem('avatar', userInfo.avatar, 60 * 60 * 1000)
            localStorage.setItem('userinfo', userInfo, 60 * 60 * 1000)
            localStorage.setItem('supplierInfo', JSON.stringify(supplierInfo), 60 * 60 * 1000)
            localStorage.setItem('UI_CACHE_DB_DICT_DATA', result.sysAllDictItems, 60 * 60 * 1000)
            commit('SET_TOKEN', result.token)
            commit('SET_INFO', userInfo)
            commit('SET_SUPPLIERINFO', supplierInfo)
            commit('SET_NAME', { username: userInfo.username,realname: userInfo.realname })
            commit('SET_AVATAR', userInfo.avatar)
            resolve(response)
          }else{
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    Logout({ commit, state }) {
      return new Promise((resolve) => {
        let logoutToken = state.token;
        commit('SET_TOKEN', '')
        commit('SET_INFO', [])
        commit('SET_SUPPLIERINFO', [])
        commit('SET_NAME', [])
        commit('SET_AVATAR', '')
        localStorage.removeItem('Access-Token')
        localStorage.removeItem('username')
        localStorage.removeItem('userinfo')
        localStorage.removeItem('supplierInfo')
        localStorage.removeItem('UI_CACHE_DB_DICT_DATA')
        sessionStorage.removeItem('redirect')
        logout(logoutToken).then(() => {
        resolve()
        }).catch(() => {
          resolve()
        })
      })
    },
  }
}
export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js